module.exports = __webpack_public_path__ + "static/media/Konsolidated.e7f771e7.jpg";